/**
 * @file 获取问题 id 与 type 的映射
 * @author Kody
 * @date 2019-10-08
 * @see http://api.umucdn.cn/project/51/interface/api/2621
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

type IOutput = Array<{ id: number; type: number }>;

export const getSectionMap = (elementId: number): Promise<IResponse<IOutput>> => {
    return fetchData(Api.GET_SECTION_MAP, { element_id: elementId }).then((res: IResponse<IOutput>) => {
        return res;
    });
};
